import React from "react";
import { localizer } from '../../Translator.js';

import { Grid, Container } from "@material-ui/core";
import { Typography } from "@material-ui/core"
import { Button } from  "@material-ui/core"

import { EmailAddressList } from "./sections/EmailAddressList";
import { EmailAddressModal } from "./sections/EmailAddressModal.js";

import { SnackbarCustom } from "../Utilities/SnackbarCustom";
import ScreenHeading from "../common/ScreenHeading.js";

import UserCli from "../../sdk/UserCli";



export class EmailAddressLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Email address list to be filled by API
      emails: [],

      // Email selected as certificate receiver
      certificateEmail: "",

      // Email selected as shipment emmission receiver
      emissionEmail: "",

      // Error message in case some request fail
      emailsError: null,

      // Flag to open/close add email address modal
      open: false
    }
  }

  /* Initilizating email address list and getting certificate & shipment emission email receiver to be marked */
  componentDidMount() {
    UserCli.GetEmails().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ emailsError: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ emails: response })
      }
    })
    UserCli.GetCertificateEmail().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ emailsError: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ certificateEmail: response })
      }
    })
    UserCli.GetShipmentEmissionEmail().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ emailsError: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ emissionEmail: response })
      }
    })
  }

  /* Actions done in child component EmailAddress & EmailAddressModal are returned here to be sending to API  */
  handleEmail = (email, option) => {

    switch (option.toUpperCase()) {
      case "POST":
        UserCli.StoreEmail(email).then(response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ emailsError: response.substring(response.indexOf(' ')) })
          } else {
            this.setState({ emails: ["*" + email, ...this.state.emails] })
          }
        })
        break;
      case "DELETE":
        var emailNotValidatedYet = "*" + email
        UserCli.RemoveEmail(email).then(response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ emailsError: response.substring(response.indexOf(' ')) })
          } else {
            var emailsFiltered = this.state.emails.filter(e => e !== email && e !== emailNotValidatedYet)
            this.setState({ emails: emailsFiltered })
          }
        })
        break;
      case "SETASCERTIFICATE":
        UserCli.SetCertificateEmail(email).then(response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ emailsError: response.substring(response.indexOf(' ')) })
          } else {
            this.setState({ certificateEmail: email })
          }
        })
        break;
      case "SETASEMISSION":
        UserCli.SetShipmentEmissionEmail(email).then(response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ emailsError: response.substring(response.indexOf(' ')) })
          } else {
            this.setState({ emissionEmail: email })
          }
        })
        break;
      default:
        break;
    }
  }
  
  /* Handle modal open/close events */
  newEmailAddress = () => {
    this.setState({ open: !this.state.open })
  }

  handleCloseModal = () => {
    this.setState({ open: false })
  }

  handleonClose = () => {
    this.setState({ emailsError: null })
  }
  
  render() {
    return (
      <React.Fragment>
        <Container>
          {/* <GridHeaderComponent container direction="row">
            <Grid item md={9}>
              <Typography className="typography-generic header-title"><i className="fa-solid fa-at font-size-30"></i> {localizer.EmailAddressTitle}</Typography>
            </Grid>
            <Grid item md={3} className="text-align-right p-10">
              <Button className="button-generic secondary-header" variant="contained" style={{ top: "calc(50% - 20px)" }} onClick={this.newEmailAddress} startIcon={<i className="fa-solid fa-plus"></i>}>
                {localizer.EmailAddressAddEmail}
              </Button>
            </Grid>
          </GridHeaderComponent> */}

          {/* Screen heading. */}
          <ScreenHeading className="typography-generic"
            icon={<i className="fa-solid fa-at icon-button-header mr-20 ml-20"></i>}
            title={localizer.EmailAddressTitle}
            button={<Button className="button-generic secondary-header" variant="contained" style={{ top: "calc(50% - 20px)" }} onClick={this.newEmailAddress} startIcon={<i className="fa-solid fa-plus"></i>}>
              {localizer.EmailAddressAddEmail}
            </Button>}
          />
          

          <Grid container direction="row" justify="center" alignItems="center" className="container-generic">
            <Typography className="typography-generic">{localizer.EmailAddressDescription}</Typography>

            <EmailAddressList emails={this.state.emails} certificateEmail={this.state.certificateEmail} emissionEmail={this.state.emissionEmail} handleEmail={this.handleEmail}></EmailAddressList>
          </Grid>

          <EmailAddressModal openModal={this.state.open} handleCloseModal={this.handleCloseModal} email={null} handleEmail={this.handleEmail}></EmailAddressModal>
        </Container>

        {/* Password close to expire warning. */}
        <SnackbarCustom message={this.state.emailsError} severity="error" handleonClose={this.handleonClose} />

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/email-address/EmailAddressLayout.js